import { StyleSheet, Platform } from 'react-native'
import { isMobile } from '../../../../tools/platform'

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 60
  },
  imageBackground: {
    width: '100%',
    height: 200
  },
  avatarContainer: {
    backgroundColor: 'white',
    position: 'absolute',
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: isMobile() ? 100 : 120,
    width: isMobile() ? 100 : 120,
    bottom: isMobile() ? -50 : -60,

    borderRadius: 200,
    overflow: 'hidden'
  },
  avatar: {
    height: isMobile() ? 100 : 120,
    width: isMobile() ? 100 : 120
  },
  topOptions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingTop: Platform.OS === 'web' ? 20 : 0
  },
  rightOptions: {
    flexDirection: 'row'
  },
  helpOption: {
    marginRight: 20
  }
})

export default styles
